export function getFolderPathToString(folderPath: string[]): string {
  return folderPath.reduce(
    (accumulator, currentValue) => (accumulator += currentValue + '/')
  );
}
